import React from 'react'
import './background-style.css'

const Background = ({ children }) => (<div className='bg'>{children}</div>)

export default Background